import * as React from 'react';
import { DeviceIntelligenceContext } from '../DeviceIntelligenceContext';

export const useDeviceIntelligence = (): DeviceIntelligenceContext => React.useContext(DeviceIntelligenceContext);
